import React, { useState, useEffect } from "react";
import axios from "axios";
import ENVIRONMENT from "../../../../environments";
import {
    Row,
    Col,
    Card,
    Table,
    Modal,
    Input,
    Button,
    Divider,
    Form,
    message,
    Select,
} from "antd";
import {
    PlusOutlined,
    InfoCircleOutlined,
    LoadingOutlined,
} from "@ant-design/icons";
import CustomerMainLayout from "../CustomerMainLayout";
import DottedLoader from "../../DottedLoader";
import FileConstants from "../../../../FileConstants";
import "./CompanyUsers.scss";

let COMPANY_ID = localStorage.getItem("company_id");
function CompanyUsers() {
    const [form] = Form.useForm();
    const [inviteModal, setInviteModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [usersList, setUsersList] = useState([]);
    const [noOfSeats, setNoOfSeats] = useState(0);
    const [usedSeats, setUsedSeats] = useState(0);
    const [selectedUser, setSelectedUser] = useState(null);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [isCompanyAdmin, setIsCompanyAdmin] = useState(false);
    const [subscriptionPlan, setSubscriptionPlan] = useState("free_trial_ai");

    useEffect(() => {
        getCompanyUsersData();
        getSubscriptionData();
    }, []);

    const getSubscriptionData = () => {
        let plan_payload = {
            "data": "subscription-plan",
            "username": localStorage.getItem('username'),
        };
        axios.post(ENVIRONMENT.GET_UPDATE_SUBSCRIPTION_DATA, plan_payload)
            .then(res => {
                if (res && res.data && res.data['name']) {
                    setSubscriptionPlan(res.data['name']);
                }
            }).catch(err => {
                console.error("Error fetching subscription plan:", err);
            });
    };

    const updateUsedSeats = (used_seats) => {
        let payload = {
            company_id: COMPANY_ID,
            used_seats: used_seats,
        };
        axios.post(ENVIRONMENT.COMPANY_UPDATE, payload);
    };

    const reinviteUser = (user) => {
        let payload = {
            email: user.email,
            invited_by: localStorage.getItem('username'),
            reinvite: true,
        };
        console.log(payload)
        axios.post(ENVIRONMENT.INVITE_USER, payload)
        .then((res) => {
            if (res && res["data"] && res["status"] == 200) {
                message.info('User invited successfully');
                getCompanyUsersData();
            }
        });
    };


    const getCompanyUsersData = () => {
        setLoader(true);
        let company_users_payload = {
            company_id: localStorage.getItem('company_id'),
        };
        axios.post(ENVIRONMENT.GET_COMPANY_USERS, company_users_payload)
        .then((res) => {
            setLoader(false);
            if (res && res["data"]) {
                if (res["data"]["users"]) {
                    const currentUsername = localStorage.getItem('username');
                    // Sort users to put current logged-in user first
                    const sortedUsers = [...res["data"]["users"]].sort((a, b) => {
                        if (a.username === currentUsername) return -1;
                        if (b.username === currentUsername) return 1;
                        return 0;
                    });
                    setUsersList(sortedUsers);
                }

                setNoOfSeats(res["data"]["no_of_seats"]);
                setUsedSeats(res["data"]["used_seats"] || res["data"]["users"].length);
                res['data']['users'].filter(user => user.username == localStorage.getItem('username') && user.role == 'admin').length > 0 ? setIsCompanyAdmin(true) : setIsCompanyAdmin(false);
            }
        });
    };


    const sendCustomerInvite = async (values) => {
        setButtonLoader(true);
        const emails = values["email_address"];
        const user_role = values["user_role"];
        const invited_by = localStorage.getItem('username');
        const company_id = localStorage.getItem('company_id');

        let successCount = 0;
        let failCount = 0;

        const invitePromises = emails.map(email => {
            let payload = {};
            payload.email = email.toLowerCase().trim();
            payload.user_role = user_role;
            payload.type = "customer";
            payload.subscription_type = subscriptionPlan;
            payload.invited_by = invited_by;
            payload.company_id = company_id;

            return axios.post(ENVIRONMENT.INVITE_USER, payload)
                .then((res) => {
                    if (res && res["data"] && res["status"] == 200) {
                        successCount++;
                    } else {
                        failCount++;
                    }
                })
                .catch(() => {
                    failCount++;
                });
        });

        await Promise.all(invitePromises);

        setButtonLoader(false);
        if (successCount > 0) {
            message.info(successCount === 1 ? 'Invitation sent successfully' : 'Invitations sent successfully');
            setInviteModal(false);
            getCompanyUsersData();
        }
        else if (failCount > 0) {
            message.error(failCount === 1 ? 'Failed to send invitation' : 'Failed to send invitations');
        }
    };

    const removeUser = (user) => {
        Modal.confirm({
            title: 'Remove User',
            content: `Are you sure you want to remove ${user.username} from the company?`,
            onOk() {
                axios.post(ENVIRONMENT.UPDATE_CUSTOMERS_SETTINGS, { 'remove_user': true, 'username': user.username, 'company_id': COMPANY_ID })
                    .then((res) => {
                        if (res && res["data"] && res["status"] == 200) {
                            message.info('User removed successfully');
                            getCompanyUsersData();
                        }
                    });
            },
        });
    };

    const makeAdmin = (user) => {
        axios.post(ENVIRONMENT.UPDATE_CUSTOMERS_SETTINGS, { 'make_admin': true, 'username': user.username, 'company_id': COMPANY_ID })
            .then((res) => {
                if (res && res["data"] && res["status"] == 200) {
                    message.info('User made admin successfully');
                    getCompanyUsersData();
                }
            });
    };

    const makeOrRemoveReviewer = (user, role) => {
        axios.post(ENVIRONMENT.UPDATE_CUSTOMERS_SETTINGS, { 'make_or_remove_reviewer': true, 'username': user.username, 'company_id': COMPANY_ID, 'role': role })
        .then((res) => {
            if (res && res["data"] && res["status"] == 200) {
                message.info('User role updated successfully');
                getCompanyUsersData();
            }
        });
    };

    const getColumns = () => {
        const baseColumns = [
            {
                title: "Name",
                key: 0,
                dataIndex: "name",
                render: (name, record) => {
                    return <span>{record.name || 'N/A'}</span>;
                }
            },
            {
                title: "Email",
                key: 1,
                dataIndex: "email",
            },
            {
                title: "Username",
                key: 2,
                dataIndex: "username",
                render: (username, record) => {
                    return <span>{record.username || 'N/A'}</span>;
                }
            },
            {
                title: "Role",
                key: 3,
                dataIndex: "signed_up",
                render: (signed_up, record) => {
                    // Helper to get role display name
                    const getRoleDisplay = (role) => {
                        if (role === 'admin') return 'Admin';
                        if (role === 'reviewer') return 'Reviewer';
                        return 'User';
                    };

                    // If user is not signed up, show Invited
                    if (signed_up !== true) {
                        return <span>Invited ({getRoleDisplay(record.role)})</span>;
                    }

                    // If user is not active, show Disabled
                    if (!record.is_active) {
                        return <span>Disabled</span>;
                    }

                    // If current user is admin, show dropdown to change roles
                    if (isCompanyAdmin) {
                        const currentUsername = localStorage.getItem('username');
                        const isCurrentUser = record.username === currentUsername;

                        // Don't show dropdown for current user
                        if (isCurrentUser) {
                            return <span>{getRoleDisplay(record.role)}</span>;
                        }

                        // Build dropdown options for role change
                        const roleOptions = [
                            { label: 'Admin', value: 'admin' },
                            { label: 'Reviewer', value: 'reviewer' },
                            { label: 'User', value: 'normal' }
                        ];

                        return (
                            <Select
                                value={record.role === 'normal' ? 'normal' : record.role}
                                style={{ width: 150 }}
                                onChange={(value) => {
                                    if (value === 'admin') {
                                        makeAdmin(record);
                                    } else if (value === 'reviewer' && record.role !== 'reviewer') {
                                        makeOrRemoveReviewer(record, 'reviewer');
                                    } else if (value === 'normal' && record.role !== 'normal') {
                                        makeOrRemoveReviewer(record, 'normal');
                                    }
                                }}
                                options={roleOptions}
                            />
                        );
                    }

                    // For non-admin users, just show the role
                    return <span>{getRoleDisplay(record.role)}</span>;
                }
            }
        ];

        // Add Actions column if user is company admin
        if (isCompanyAdmin) {
            baseColumns.push({
                title: "Actions",
                key: 4,
                dataIndex: "actions",
                render: (_, record) => {
                    // Only show actions for signed_up users
                    if (record.signed_up === true) {
                        const currentUsername = localStorage.getItem('username');
                        const isCurrentUser = record.username === currentUsername;

                        // Don't show remove button for current user
                        if (isCurrentUser) {
                            return <span>-</span>;
                        }

                        return (
                            <Button
                                danger
                                onClick={() => removeUser(record)}
                                style={{ width: 120 }}
                            >
                                Remove User
                            </Button>
                        );
                    }
                        return (
                            <Button
                                onClick={() => reinviteUser(record)}
                                style={{
                                    width: 120,
                                    color: "#266DD7",
                                    borderColor: "#266DD7",
                                    backgroundColor: "white",
                                }}
                            >
                                Reinvite User
                            </Button>
                        );
                    return <span>-</span>;
                }
            });
        }

        return baseColumns;
    };

    const columns = getColumns();




    return (
        <>
            {loader ? (
                <DottedLoader />
            ) : (
                <>
                    <Row style={{ justifyContent: "space-between", backgroundColor: "#FAFAFA" }}>
                        <Col span={5}>
                                <div style={{ padding: 20 }}>
                                    <div>
                                        <span className="manrope f-20 w-600">Total Seats in Plan</span>
                                    </div>
                                    <div className="mt-10">
                                        <span
                                            className="manrope f-20 w-600"
                                            style={{ color: "#262626" }}
                                        >
                                            {noOfSeats || 'N/A'}
                                        </span>
                                    </div>
                                </div>
                        </Col>

                        <Col span={5}>
                                <div style={{ padding: 20 }}>
                                    <div>
                                        <span className="manrope f-20 w-600">Current Users</span>
                                    </div>
                                    <div className="mt-10">
                                        <span
                                            className="manrope f-20 w-600"
                                            style={{ color: "#262626" }}
                                        >
                                            {usedSeats || 'N/A'}
                                        </span>
                                    </div>
                                </div>
                        </Col>

                        <Col span={5}>
                                <div style={{ padding: 20 }}>
                                    <div>
                                        <span className="manrope f-20 w-600">Remaining Seats</span>
                                    </div>
                                    <div className="mt-10">
                                        <span
                                            className="manrope f-20 w-600"
                                            style={{ color: "#262626" }}
                                        >
                                            {noOfSeats - usedSeats > 0 ? noOfSeats - usedSeats : 'N/A'}
                                        </span>
                                    </div>
                                </div>
                        </Col>
                        {isCompanyAdmin &&
                        <Col span={9} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", paddingRight: "20px"}}>
                            {usedSeats >= noOfSeats ? (
                                <div className="manrope f-14" style={{ backgroundColor: "#F0F0F0", padding: "15px" }}>
                                    Remove a user to add a new one
                                </div>
                            ) : (
                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setInviteModal(true)}
                                    style={{
                                        backgroundColor: "#266DD7",
                                        padding: "15px",
                                        height: "auto",
                                    }}
                                >
                                    Add New User
                                </Button>
                            )}
                        </Col>}
                    </Row>

                    <div className="company-users-container">
                        {/* Sidebar */}
                        <div className="company-users-sidebar">
                            <span className="manrope f-16 w-700 lh-26 black-085">Current</span>
                            <span className="manrope f-16 w-700 lh-26 black-085">Users</span>
                        </div>

                        {/* Content */}
                        <div className="company-users-content">
                            <Table
                                columns={columns}
                                dataSource={usersList}
                                bordered={false}
                                pagination={false}
                                className="company-users-table"
                            />
                        </div>
                    </div>

                    <Modal
                        className="silo-success-modal"
                        title="Add New User"
                        centered={true}
                        closable={true}
                        destroyOnClose={true}
                        maskClosable={true}
                        width={700}
                        onCancel={() => setInviteModal(false)}
                        visible={inviteModal}
                        bodyStyle={{ padding: 0 }}
                        footer={null}
                    >
                        <div style={{ padding: "30px" }}>
                            <Form form={form} onFinish={sendCustomerInvite}>
                                <div>
                                    <span>
                                        User Email <span style={{ color: "red" }}>*</span>
                                    </span>
                                </div>
                                <div style={{ marginTop: 10 }}>
                                    <Form.Item
                                        name="email_address"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please enter at least one email address.",
                                            },
                                            {
                                                validator: (_, value) => {
                                                    if (!value || value.length === 0) {
                                                        return Promise.resolve();
                                                    }
                                                    const emailRegex = /^\S+@\S+\.\S+$/;
                                                    const invalidEmails = value.filter(email => !emailRegex.test(email.trim()));
                                                    if (invalidEmails.length > 0) {
                                                        return Promise.reject(new Error(`Invalid format: ${invalidEmails.join(', ')}`));
                                                    }
                                                    if (value.length > (noOfSeats - usedSeats)) {
                                                        return Promise.reject(new Error(`You can only invite up to ${noOfSeats - usedSeats} more users.`));
                                                    }
                                                    return Promise.resolve();
                                                }
                                            }
                                        ]}
                                    >
                                        <Select
                                            mode="tags"
                                            className="invite-role-select"
                                            style={{ width: '100%' }}
                                            placeholder="Type User Emails and press Enter"
                                            tokenSeparators={[',', ' ']}
                                            notFoundContent={null}
                                            onChange={(value) => {
                                                if (value.length > (noOfSeats - usedSeats)) {
                                                    form.setFields([
                                                        {
                                                            name: 'email_address',
                                                            errors: [`You can only invite up to ${noOfSeats - usedSeats} more users.`],
                                                        },
                                                    ]);
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                </div>

                                <div style={{ marginTop: 20 }}>
                                    <span>
                                        User Role <span style={{ color: "red" }}>*</span>
                                    </span>
                                </div>
                                <div style={{ marginTop: 10 }}>
                                    <Form.Item
                                        name="user_role"
                                        initialValue="normal"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please select a user role.",
                                            },
                                        ]}
                                    >
                                        <Select
                                            className="invite-role-select"
                                            options={[
                                                { label: 'Admin', value: 'admin' },
                                                { label: 'Reviewer', value: 'reviewer' },
                                                { label: 'User', value: 'normal' }
                                            ]}
                                        />
                                    </Form.Item>
                                </div>

                                <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                                    <Form.Item shouldUpdate>
                                        {() => (
                                            <Button
                                                htmlType="submit"
                                                disabled={
                                                    buttonLoader ||
                                                    !form.getFieldValue("email_address") ||
                                                    form.getFieldValue("email_address").length === 0 ||
                                                    form.getFieldsError().filter(({ errors }) => errors.length).length > 0
                                                }
                                                className="modal-okay square font-14"
                                            >
                                                {buttonLoader ? <LoadingOutlined /> : ""}
                                                Send Invitation
                                            </Button>
                                        )}
                                    </Form.Item>
                                </div>
                            </Form>
                        </div>
                    </Modal>
                </>
            )}
            </>
    );
}

export default CompanyUsers;